"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultBase = exports.DocumentListBase = exports.DocumentBase = exports.Pagination = exports.Page = exports.SortOption = exports.VersionNumber = exports.Facet = exports.Filter = exports.Stats = void 0;
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/no-explicit-any */
const json2typescript_1 = require("json2typescript");
/* tslint:disable */
let Stats = class Stats {
    constructor() {
        this.totalHits = undefined;
        this.searchEngineTimeInMillis = undefined;
        this.searchEngineRoundTripTimeInMillis = undefined;
        this.searchProcessingTimeInMillis = undefined;
    }
};
exports.Stats = Stats;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('totalHits', Number),
    tslib_1.__metadata("design:type", Number)
], Stats.prototype, "totalHits", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('searchEngineTimeInMillis', Number),
    tslib_1.__metadata("design:type", Number)
], Stats.prototype, "searchEngineTimeInMillis", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('searchEngineRoundTripTimeInMillis', Number),
    tslib_1.__metadata("design:type", Number)
], Stats.prototype, "searchEngineRoundTripTimeInMillis", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('searchProcessingTimeInMillis', Number),
    tslib_1.__metadata("design:type", Number)
], Stats.prototype, "searchProcessingTimeInMillis", void 0);
exports.Stats = Stats = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('Stats')
], Stats);
let Filter = class Filter {
    constructor() {
        this.displayName = undefined;
        this.selected = undefined;
        this.query = undefined;
        this.count = undefined;
        this.queryValue = undefined;
        this.children = undefined;
    }
};
exports.Filter = Filter;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('displayName', String),
    tslib_1.__metadata("design:type", String)
], Filter.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('selected', Boolean),
    tslib_1.__metadata("design:type", Boolean)
], Filter.prototype, "selected", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('query', String),
    tslib_1.__metadata("design:type", String)
], Filter.prototype, "query", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('count', Number),
    tslib_1.__metadata("design:type", Number)
], Filter.prototype, "count", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('queryValue', String),
    tslib_1.__metadata("design:type", String)
], Filter.prototype, "queryValue", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('children', [json2typescript_1.Any]),
    tslib_1.__metadata("design:type", Array)
], Filter.prototype, "children", void 0);
exports.Filter = Filter = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('Filter')
], Filter);
let Facet = class Facet {
    constructor() {
        this.id = undefined;
        this.displayName = undefined;
        this.selectionType = undefined;
        this.multipleLevels = undefined;
        this.filters = undefined;
    }
};
exports.Facet = Facet;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('id', String),
    tslib_1.__metadata("design:type", String)
], Facet.prototype, "id", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('displayName', String),
    tslib_1.__metadata("design:type", String)
], Facet.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('selectionType', String),
    tslib_1.__metadata("design:type", String)
], Facet.prototype, "selectionType", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('multipleLevels', Boolean),
    tslib_1.__metadata("design:type", Boolean)
], Facet.prototype, "multipleLevels", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('filters', [Filter]),
    tslib_1.__metadata("design:type", Array)
], Facet.prototype, "filters", void 0);
exports.Facet = Facet = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('Facet')
], Facet);
let VersionNumber = class VersionNumber {
    constructor() {
        this.id = undefined;
        this.displayName = undefined;
    }
};
exports.VersionNumber = VersionNumber;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('id', String),
    tslib_1.__metadata("design:type", String)
], VersionNumber.prototype, "id", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('displayName', String),
    tslib_1.__metadata("design:type", String)
], VersionNumber.prototype, "displayName", void 0);
exports.VersionNumber = VersionNumber = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('VersionNumber')
], VersionNumber);
let SortOption = class SortOption {
    constructor() {
        this.displayName = undefined;
        this.selected = undefined;
        this.query = undefined;
    }
};
exports.SortOption = SortOption;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('displayName', String),
    tslib_1.__metadata("design:type", String)
], SortOption.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('selected', Boolean),
    tslib_1.__metadata("design:type", Boolean)
], SortOption.prototype, "selected", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('query', String),
    tslib_1.__metadata("design:type", String)
], SortOption.prototype, "query", void 0);
exports.SortOption = SortOption = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('SortOption')
], SortOption);
let Page = class Page {
    constructor() {
        this.displayName = undefined;
        this.selected = undefined;
        this.query = undefined;
    }
};
exports.Page = Page;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('displayName', String),
    tslib_1.__metadata("design:type", String)
], Page.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('selected', Boolean),
    tslib_1.__metadata("design:type", Boolean)
], Page.prototype, "selected", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('query', String),
    tslib_1.__metadata("design:type", String)
], Page.prototype, "query", void 0);
exports.Page = Page = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('Page')
], Page);
let Pagination = class Pagination {
    constructor() {
        this.offset = undefined;
        this.hitsPerPage = undefined;
        this.firstPage = undefined;
        this.previousPage = undefined;
        this.nextPage = undefined;
        this.lastPage = undefined;
        this.pages = undefined;
    }
};
exports.Pagination = Pagination;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('offset', Number),
    tslib_1.__metadata("design:type", Number)
], Pagination.prototype, "offset", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('hitsPerPage', Number),
    tslib_1.__metadata("design:type", Number)
], Pagination.prototype, "hitsPerPage", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('firstPage', Page, true),
    tslib_1.__metadata("design:type", Page)
], Pagination.prototype, "firstPage", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('previousPage', Page, true),
    tslib_1.__metadata("design:type", Page)
], Pagination.prototype, "previousPage", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('nextPage', Page, true),
    tslib_1.__metadata("design:type", Page)
], Pagination.prototype, "nextPage", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('lastPage', Page, true),
    tslib_1.__metadata("design:type", Page)
], Pagination.prototype, "lastPage", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('pages', [Page]),
    tslib_1.__metadata("design:type", Array)
], Pagination.prototype, "pages", void 0);
exports.Pagination = Pagination = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('Pagination')
], Pagination);
let DocumentBase = class DocumentBase {
    constructor() {
        this.id = undefined;
        this.location = undefined;
    }
};
exports.DocumentBase = DocumentBase;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('id', String),
    tslib_1.__metadata("design:type", String)
], DocumentBase.prototype, "id", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('location', json2typescript_1.Any, true),
    tslib_1.__metadata("design:type", Object)
], DocumentBase.prototype, "location", void 0);
exports.DocumentBase = DocumentBase = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('DocumentBase')
], DocumentBase);
let DocumentListBase = class DocumentListBase {
    constructor() {
        this.id = undefined;
        this.displayName = undefined;
        this.numberOfHits = undefined;
        this.pagination = undefined;
        this.sortOptions = undefined;
        // Should be override in child classes
        this.documents = undefined;
    }
};
exports.DocumentListBase = DocumentListBase;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('id', String),
    tslib_1.__metadata("design:type", String)
], DocumentListBase.prototype, "id", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('displayName', String),
    tslib_1.__metadata("design:type", String)
], DocumentListBase.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('numberOfHits', Number),
    tslib_1.__metadata("design:type", Number)
], DocumentListBase.prototype, "numberOfHits", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('pagination', Pagination),
    tslib_1.__metadata("design:type", Pagination)
], DocumentListBase.prototype, "pagination", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('sortOptions', [SortOption]),
    tslib_1.__metadata("design:type", Array)
], DocumentListBase.prototype, "sortOptions", void 0);
exports.DocumentListBase = DocumentListBase = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('DocumentListBase')
], DocumentListBase);
let SearchResultBase = class SearchResultBase {
    constructor() {
        this.stats = undefined;
        this.versionNumber = undefined;
        this.facets = undefined;
        // Should be override in child classes
        this.documentList = undefined;
    }
};
exports.SearchResultBase = SearchResultBase;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('stats', Stats),
    tslib_1.__metadata("design:type", Stats)
], SearchResultBase.prototype, "stats", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('versionNumber', VersionNumber),
    tslib_1.__metadata("design:type", VersionNumber)
], SearchResultBase.prototype, "versionNumber", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('facets', [Facet]),
    tslib_1.__metadata("design:type", Array)
], SearchResultBase.prototype, "facets", void 0);
exports.SearchResultBase = SearchResultBase = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('SearchResultBase')
], SearchResultBase);
/* tslint:enable */
